import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentIt = () => {
    return (
        <HighlightedText
            text="HAI VINTO 400 GIRI GRATUITI"
            highlights={[{ word: '400' }]}
            breakAfterWords={['VINTO']}
            className={styles.text_content}
        />
    )
}
